import React from 'react';

const IconEmber = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px">
    <path
      fill="#E04E39"
      d="M24 6C14.06 6 6 14.06 6 24s8.06 18 18 18 18-8.06 18-18S33.94 6 24 6zm0 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 24c-5.52 0-10-4.48-10-10 0-1.66.41-3.22 1.13-4.59.55 1.27 1.73 2.14 3.12 2.14 1.93 0 3.5-1.57 3.5-3.5S20.43 22 18.5 22c-.45 0-.88.09-1.28.24.58-2.31 2.56-3.94 4.78-3.94 2.76 0 5 2.24 5 5 0 2.2-1.43 4.06-3.41 4.73.08.27.41 1.27.41 2.77 0 3.31-2.69 6-6 6z"
    />
  </svg>
);

export default IconEmber;
